import { Component, Input } from '@angular/core';

@Component({
    selector: 'page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss'],
    standalone: false
})
export class PageComponent {
  @Input() fullWidth: boolean = false;

  @Input() productBadge: ProductBadge;
  @Input() productBadges: ProductBadge[];

  @Input() name: string;
  @Input() description: string;
  @Input() column: number = 1;
  @Input() headerType: 'h1' | 'h2' = 'h1';

  /**
   * Additive (default false): render the product badge INLINE inside the h2 heading
   * (PSTX wordmark immediately followed by the title text, e.g. "PSTX Transaction"),
   * instead of the badge block stacked above a separate title. Only takes effect for
   * `headerType === 'h2'` with a single `productBadge`. Leaving it false keeps every
   * other page that uses <page> visually unchanged.
   */
  @Input() inlineBadge: boolean = false;

  get useInlineBadge(): boolean {
    return this.inlineBadge && !!this.productBadge && this.headerType === 'h2';
  }
}

type ProductBadge = 'ecf' | 'pstx' | 'ieo';
